// run a series of promises in parallel, limited to maxConcurrency at a time
// returns a promise of an array of expected results in the order that promises resolve (random ish).
// so this is only useful if you don't care what order you get the results
// Promises that fail do not return a result, so the array may be shorter
// nextTask() should be a generator function that yields promises. If you pass an array of promises, they are already started so you get no throttle

export async function throttlePromises<T>(
  maxConcurrent: number,
  nextTask: Iterator<Promise<T>>,
): Promise<Array<T>> {
  if (maxConcurrent < 1) throw new Error('Invalid argument: maxConcurrent');

  return new Promise<Array<T>>((done) => {
    const completed: Array<T> = [];
    let active = 0;

    function startNextTask() {
      const next = nextTask.next();
      if (next.done) {
        if (active <= 0) done(completed);
      } else {
        active++;
        next.value.then(taskComplete).catch(taskFailed);
      }
    }

    function taskComplete(result: T) {
      active--;
      completed.push(result);
      startNextTask();
    }

    function taskFailed() {
      active--;
      // could add failed.push here
      startNextTask();
    }

    // start the first maxConcurrency promises
    for (let n = 0; n < maxConcurrent; n++) {
      startNextTask();
    }
  });
}
